<template>
  <div>
    <template v-if="dataSource.length">
      <slot name="content" />
    </template>
    <div
      v-if="!dataSource.length"
      :class="{ 'flex-center': true, 'flex-page-center': isSetPageCenter }"
      :style="styleObj"
    >
      <div>
        <a-spin v-if="loading" size="large" />
        <a-empty v-else-if="!loading && isEmpty" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EmptyData',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    styleObj: {
      type: Object,
      default: () => {},
    },
    isEmpty: {
      type: Boolean,
      default: true,
    },
    isSetPageCenter: {
      type: Boolean,
      default: false,
    },
    dataSource: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {}
  },
  methods: {},
}
</script>

<style lang="less" scoped></style>
